import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { getApiErrorMessage } from '../shared/api-error.util';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  private snackbarSubject = new Subject<any>();
  public snackbarState = this.snackbarSubject.asObservable();

  // constructor(public snackBar: MatSnackBar) { }

  showErrorSnackBar(message:string, action?:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'error'
    });
  }

  showApiErrorSnackBar(error: unknown, fallback = 'Something went wrong.') {
    this.showErrorSnackBar(getApiErrorMessage(error, fallback));
  }
  showSuccessSnackBar(message:string, action?:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'success'
    });
  }

  showWarningSnackBar(message:string, action?:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'warning'
    });
  }
  
  showAlertInfoSnackBar(message:string, action?:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'info-warning'
    });
  }

  showInfoSnackBar(message:string, action?:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'information'
    });
  }


}
